export const LG_MIN = 1200;
export const MD_MAX = LG_MIN - 1;
export const MD_MIN = 1026; // Overriden by wkda main website
export const SM_MAX = MD_MIN - 1;
export const SM_MIN = 768;
export const XS_MAX = SM_MIN - 1;
export const SCREEN_LG_MIN = `(min-width: ${LG_MIN}px)`;
export const SCREEN_MD_MAX = `(max-width: ${MD_MAX}px)`;
export const SCREEN_MD_MIN = `(min-width: ${MD_MIN}px)`;
export const SCREEN_SM_MAX = `(max-width: ${SM_MAX}px)`;
export const SCREEN_SM_MIN = `(min-width: ${SM_MIN}px)`;
export const SCREEN_XS_MAX = `(max-width: ${XS_MAX}px)`;
export const SCREEN_MD = `(min-width: ${MD_MIN}px) and (max-width: ${MD_MAX}px)`;
export const SCREEN_SM = `(min-width: ${SM_MIN}px) and (max-width: ${SM_MAX}px)`;
